"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertTaskViewColumnConfig = exports.readTaskViewColumnConfig = exports.readTaskViewColumnConfigsStore = exports.TASK_VIEW_COLUMN_CONFIGS_STORAGE_KEY = exports.MAX_TASK_VIEW_COLUMN_CONFIGS = void 0;
/** Max number of records retained. Change here to adjust the cap. */
exports.MAX_TASK_VIEW_COLUMN_CONFIGS = 50;
exports.TASK_VIEW_COLUMN_CONFIGS_STORAGE_KEY = 'enrichai.hlqa.taskViewColumnConfigs.v1';
const EMPTY_STORE = { order: [], byKey: {} };
const isValidStore = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return Array.isArray(candidate.order) && typeof candidate.byKey === 'object' && candidate.byKey !== null;
};
/**
 * Reads and validates the whole store. Any corruption or read failure resets to an
 * empty store so a bad payload can never break the task view.
 */
const readTaskViewColumnConfigsStore = (ls) => {
    try {
        const raw = ls.getItem(exports.TASK_VIEW_COLUMN_CONFIGS_STORAGE_KEY);
        return isValidStore(raw) ? raw : EMPTY_STORE;
    }
    catch (_a) {
        return EMPTY_STORE;
    }
};
exports.readTaskViewColumnConfigsStore = readTaskViewColumnConfigsStore;
const readTaskViewColumnConfig = (ls, key) => (0, exports.readTaskViewColumnConfigsStore)(ls).byKey[key];
exports.readTaskViewColumnConfig = readTaskViewColumnConfig;
/**
 * Inserts or overwrites the config for `key`.
 * - Existing key: overwrites in place, leaving insertion order untouched.
 * - New key: appended as newest; if the cap is exceeded, the oldest record
 *   (front of `order`) is evicted from both `order` and `byKey`.
 */
const upsertTaskViewColumnConfig = (ls, key, config) => {
    const store = (0, exports.readTaskViewColumnConfigsStore)(ls);
    const keyExists = key in store.byKey;
    const order = keyExists ? store.order : [...store.order, key];
    const byKey = Object.assign(Object.assign({}, store.byKey), { [key]: config });
    while (order.length > exports.MAX_TASK_VIEW_COLUMN_CONFIGS) {
        const evictedKey = order.shift();
        if (evictedKey !== undefined) {
            delete byKey[evictedKey];
        }
    }
    const nextStore = { order, byKey };
    ls.setItem(exports.TASK_VIEW_COLUMN_CONFIGS_STORAGE_KEY, nextStore);
    return nextStore;
};
exports.upsertTaskViewColumnConfig = upsertTaskViewColumnConfig;
